// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*************** 
Line animation 
***************/

@keyframes sampleMoving {
  0% {
    stroke-dashoffset: var(--dashOffsetValueReversed);
  }

  100% {
    stroke-dashoffset: var(--dashOffsetValue);
  }
}

svg #interlock_graphics #lines-active {
  --dashArrayValue: 50;
  --dashOffsetValue: -50;
  --dashOffsetValueReversed: 50;
  --animationSpeed: 1s;
}

/* svg.default #interlock_graphics #lines-active {
  --lineColor: blue;
  animation: sampleMoving var(--animationSpeed) linear 0s infinite;
  stroke-dasharray: var(--dashArrayValue);
  stroke-dashoffset: var(--dashOffsetValue);
  
} */

svg.d1 #interlock_graphics #line-pigLauncher-to-d1-active {
  stroke: blue;
  animation: sampleMoving var(--animationSpeed) linear 0s infinite;
  stroke-dasharray: var(--dashArrayValue);
  stroke-dashoffset: var(--dashOffsetValue);
  animation-play-state: running;
}

svg.v1 #interlock_graphics #line-pigLauncher-to-v1-active {
  stroke: blue;
  animation: sampleMoving var(--animationSpeed) linear 0s infinite;
  stroke-dasharray: var(--dashArrayValue);
  stroke-dashoffset: var(--dashOffsetValue);
  animation-play-state: running;
  animation-direction: reverse;
}

svg.m1 #interlock_graphics #line-pigLauncher-to-m1-active {
  stroke: blue;
  animation: sampleMoving var(--animationSpeed) linear 0s infinite;
  stroke-dasharray: var(--dashArrayValue);
  stroke-dashoffset: var(--dashOffsetValue);
  animation-play-state: running;
}

svg.k1 #interlock_graphics #line-pigLauncher-to-k1-active {
  stroke: blue;
  animation: sampleMoving var(--animationSpeed) linear 0s infinite;
  stroke-dasharray: var(--dashArrayValue);
  stroke-dashoffset: var(--dashOffsetValue);
  animation-play-state: running;
  animation-direction: reverse;
}

svg.default #interlock_graphics #line-m1-k1-active {
  stroke: blue;
  animation: sampleMoving var(--animationSpeed) linear 0s infinite;
  stroke-dasharray: var(--dashArrayValue);
  stroke-dashoffset: var(--dashOffsetValue);
  animation-play-state: running;
  animation-direction: reverse;
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/components/graphicalView/2D/alcatraz_styles.css"],"names":[],"mappings":"AAAA;;eAEe;;AAEf;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;;;;;GAMG;;AAEH;EACE,YAAY;EACZ,gEAAgE;EAChE,uCAAuC;EACvC,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gEAAgE;EAChE,uCAAuC;EACvC,yCAAyC;EACzC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gEAAgE;EAChE,uCAAuC;EACvC,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gEAAgE;EAChE,uCAAuC;EACvC,yCAAyC;EACzC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,gEAAgE;EAChE,uCAAuC;EACvC,yCAAyC;EACzC,6BAA6B;EAC7B,4BAA4B;AAC9B","sourcesContent":["/*************** \nLine animation \n***************/\n\n@keyframes sampleMoving {\n  0% {\n    stroke-dashoffset: var(--dashOffsetValueReversed);\n  }\n\n  100% {\n    stroke-dashoffset: var(--dashOffsetValue);\n  }\n}\n\nsvg #interlock_graphics #lines-active {\n  --dashArrayValue: 50;\n  --dashOffsetValue: -50;\n  --dashOffsetValueReversed: 50;\n  --animationSpeed: 1s;\n}\n\n/* svg.default #interlock_graphics #lines-active {\n  --lineColor: blue;\n  animation: sampleMoving var(--animationSpeed) linear 0s infinite;\n  stroke-dasharray: var(--dashArrayValue);\n  stroke-dashoffset: var(--dashOffsetValue);\n  \n} */\n\nsvg.d1 #interlock_graphics #line-pigLauncher-to-d1-active {\n  stroke: blue;\n  animation: sampleMoving var(--animationSpeed) linear 0s infinite;\n  stroke-dasharray: var(--dashArrayValue);\n  stroke-dashoffset: var(--dashOffsetValue);\n  animation-play-state: running;\n}\n\nsvg.v1 #interlock_graphics #line-pigLauncher-to-v1-active {\n  stroke: blue;\n  animation: sampleMoving var(--animationSpeed) linear 0s infinite;\n  stroke-dasharray: var(--dashArrayValue);\n  stroke-dashoffset: var(--dashOffsetValue);\n  animation-play-state: running;\n  animation-direction: reverse;\n}\n\nsvg.m1 #interlock_graphics #line-pigLauncher-to-m1-active {\n  stroke: blue;\n  animation: sampleMoving var(--animationSpeed) linear 0s infinite;\n  stroke-dasharray: var(--dashArrayValue);\n  stroke-dashoffset: var(--dashOffsetValue);\n  animation-play-state: running;\n}\n\nsvg.k1 #interlock_graphics #line-pigLauncher-to-k1-active {\n  stroke: blue;\n  animation: sampleMoving var(--animationSpeed) linear 0s infinite;\n  stroke-dasharray: var(--dashArrayValue);\n  stroke-dashoffset: var(--dashOffsetValue);\n  animation-play-state: running;\n  animation-direction: reverse;\n}\n\nsvg.default #interlock_graphics #line-m1-k1-active {\n  stroke: blue;\n  animation: sampleMoving var(--animationSpeed) linear 0s infinite;\n  stroke-dasharray: var(--dashArrayValue);\n  stroke-dashoffset: var(--dashOffsetValue);\n  animation-play-state: running;\n  animation-direction: reverse;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
